import { render, staticRenderFns } from "./OldOrder.vue?vue&type=template&id=fd2e7abc&scoped=true&"
import script from "./OldOrder.vue?vue&type=script&lang=js&"
export * from "./OldOrder.vue?vue&type=script&lang=js&"
import style0 from "./OldOrder.vue?vue&type=style&index=0&id=fd2e7abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2e7abc",
  null
  
)

export default component.exports